import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <a href="mailto:mbedrna@ctenaraky.cz" className="footer-contact">
                mbedrna@ctenaraky.cz
            </a>
        </footer>
    );
}

export default Footer;
